<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiFlag } from "@mdi/js"

export default {
  name: "FlagIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiFlag,
    }
  }
}
</script>
